function changeDesignDefault(){
    const displayScreenEl = document.getElementById("displayScreen");
    displayScreenEl.style.width = window.newDisplayScreenWidth + "px";
    // we are not sure what this is about, but it interferes with the previewer so we keep it as it is for the normal setup
    if (!window.inPreviewMode) {
      displayScreenEl.style.height = window.canvasWidth + "px";
    }

    document.body.style.background = bgColor_setup;
    // reset the background image
    displayScreenEl.style.backgroundImage = 'none';
    document.body.style.color = textColor_setup;
    document.body.style.fontSize = textSize_setup + "px";
    document.documentElement.style.background = bgColor_setup;
    document.documentElement.style.color = textColor_setup;
    document.documentElement.style.fontSize = textSize_setup + "px";

    displayScreenEl.style.fontSize = textSize_setup + "px";

    setDisplayVariables(window.adjuster);
}